import { useEffect } from 'react';

interface BusinessInfoModalProps {
  onClose: () => void;
}

export default function BusinessInfoModal({ onClose }: BusinessInfoModalProps) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  const infoRows = [
    { label: '상호', value: '주식회사 위딘' },
    { label: '사업자등록번호', value: '396-86-02897' },
    { label: '주소', value: '인천광역시 연수구 인천타워대로 323, 에이동 31층 에스 216호' },
    { label: '통신판매업 신고번호', value: '제2024-인천연수구-0083호' },
    { label: '대표자', value: '전가혜' },
    { label: '고객센터', value: '1644-0000' },
    { label: '운영 시간', value: '평일 10:00 – 17:00 (점심 12:00 – 13:00 / 주말·공휴일 휴무)' },
    { label: '이메일', value: 'cs@within.co.kr' },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 bg-[#2C2825] border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl">

        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-white/10 flex-shrink-0">
          <h2 className="text-white text-lg font-medium tracking-wide">사업자 정보</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-white text-lg"></i>
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto px-8 py-6 space-y-6 text-white/60 text-sm leading-relaxed">

          <div>
            <p className="text-white/30 text-xs mb-5">
              아래는 전자상거래 등에서의 소비자보호에 관한 법률에 따라 공시하는 사업자 정보입니다.
            </p>
            <div className="bg-white/5 rounded-xl overflow-hidden">
              {infoRows.map((row, idx) => (
                <div
                  key={row.label}
                  className={`flex gap-4 px-5 py-3.5 ${idx !== infoRows.length - 1 ? 'border-b border-white/5' : ''}`}
                >
                  <span className="text-white/40 text-xs w-36 flex-shrink-0 pt-0.5">{row.label}</span>
                  <span className="text-white/70 text-xs break-all">{row.value}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white text-sm font-medium mb-3">구매 안전 서비스</h3>
            <div className="bg-white/5 rounded-xl px-5 py-4 space-y-2">
              <p className="text-white/60 text-xs leading-relaxed">
                위딘은 고객님의 안전한 쇼핑을 위해 구매 안전 서비스(에스크로)를 운영합니다.
                결제 대금은 상품 배송이 완료될 때까지 안전하게 보호됩니다.
              </p>
              <p className="text-white/40 text-xs">
                ※ 에스크로 서비스에 관한 문의는 고객센터로 연락하시기 바랍니다.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-white text-sm font-medium mb-3">호스팅 서비스</h3>
            <div className="bg-white/5 rounded-xl px-5 py-4">
              <p className="text-white/60 text-xs leading-relaxed">
                본 쇼핑몰은 클라우드 기반 호스팅 서비스를 통해 운영됩니다.
                서비스 관련 문의는 고객센터(1644-0000)를 이용해 주시기 바랍니다.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-white text-sm font-medium mb-3">소비자 피해 보상 보험</h3>
            <div className="bg-white/5 rounded-xl px-5 py-4">
              <p className="text-white/60 text-xs leading-relaxed">
                위딘은 소비자 피해를 신속하게 처리하고 보상하기 위해 소비자 피해 보상 보험(공제)에 가입되어 있습니다.
                피해 보상 및 분쟁 처리 관련 사항은 한국소비자원(www.kca.go.kr / 1372)을 통해서도 도움을 받으실 수 있습니다.
              </p>
            </div>
          </div>

          <p className="text-white/30 text-xs pt-4 border-t border-white/10">
            위 내용은 전자상거래법 제10조에 따른 사업자 정보 공개 사항입니다.
          </p>
        </div>

        {/* Footer */}
        <div className="px-8 py-5 border-t border-white/10 flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full bg-[#8B7355] text-white py-3 rounded-full text-sm font-medium hover:bg-[#7A6548] transition-colors cursor-pointer whitespace-nowrap"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
